import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: "https://cd87b526448cb4b6f5765878fc58c230@o4511016742223872.ingest.us.sentry.io/4511016746614784",
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === 'production',
  tracesSampleRate: 0.2,
  // Filter out third-party noise that isn't actionable for us.
  // - WKWebView postMessage: Reddit Pixel's iOS in-app browser path -
  //   fires whenever an iPhone user clicks a Reddit ad and lands here.
  //   Pure SDK noise, not a real error.
  // - ResizeObserver loop: a benign Chrome warning that browsers raise
  //   on virtualized lists; doesn't represent a real failure.
  ignoreErrors: [
    /WKWebView API client did not respond to this postMessage/i,
    /ResizeObserver loop/i,
  ],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();

// ⚠️ Service worker RETIRED (caused stale-shell white screens). Do NOT register
// one. Actively unregister any SW a returning user still has, and clear its
// caches, so they self-heal on this load instead of waiting for the sw.js
// self-destruct to fire.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {});
  if (window.caches) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}

// Front-end crash reporter → POST to /api/client-error so a white screen leaves
// a trace in Railway logs without the user needing devtools open. Catches
// uncaught errors AND unhandled promise rejections (failed dynamic imports show
// up here). Best-effort; never throws.
(function installErrorReporter() {
  const API = (process.env.REACT_APP_API_URL || '') + '/api/client-error';
  const seen = new Set();
  const report = (kind, message, stack) => {
    try {
      const key = kind + '|' + (message || '').slice(0, 120);
      if (seen.has(key)) return; // dedupe a storm
      seen.add(key);
      const body = JSON.stringify({ kind, message: String(message || '').slice(0, 500), stack: String(stack || '').slice(0, 1500), url: window.location.href, ua: navigator.userAgent });
      if (navigator.sendBeacon) navigator.sendBeacon(API, new Blob([body], { type: 'application/json' }));
      else fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    } catch {}
  };
  window.addEventListener('error', (e) => report('window.error', e.message || (e.error && e.error.message), e.error && e.error.stack));
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason || {};
    report('unhandledrejection', r.message || String(r), r.stack);
  });
})();
